<div id="page-container">
  <div id="content-wrap">
    <div class="fullScreen">
      <headband [accountName]="accountName" [maxVoters]="maxVoters" [hasHotline]="hasHotline"
        (hotlinePopupChange)="hotlinePopup = $event" (optionsPopupChange)="changeSubscription()"
        (buyPopupEvent)="shouldBuyCredits = $event"></headband>
    </div>

    <div class="flex content-evenly">
      <div>
        <img src="assets/v8te.png" id="logo">
      </div>
      <main class="w-70p flex flex-column mt-40 p-20" style="height: 100vh;">
        <div id="suspended-page-header" class="flex content-between mb-20">
          <div class="flex gap-10 align-items-center">
            <div class="arrow-container pointer" style="margin-right: 10px;" (click)="navigateArrow()">
              <img class="arrow" src="assets/arrow-left.svg">
              <p class="dark-blue text-sm" style="margin: 0;">Retour</p>
            </div>

            <div>
              <p class="bold light-blue text-xl no-margin mb-10">Gestion des comptes bloqués</p>
              <p class="grey no-margin">Surveillez et gérez les comptes bloqués pour des raisons de sécurité</p>
            </div>

          </div>

          <div class="bg-pastel-yellow p-20 flex gap-10 radius-10" style="border: solid 1px #F9DF80">
            <img src="assets/warning-icon.svg" alt="warning icon" width="20px">

            <div>
              <p class="brown no-margin"><span class="bold">{{suspended.length}} comptes</span> sont temporairement
                bloqués.</p>
            </div>
          </div>
        </div>

        <div style="width: 100%;">
          <div class="radius-10" style="border: solid 1px #E3F2FF;">
            <div class="bg-light-gray p-20 flex align-items-center gap-10" style="border-bottom: solid 1px #DCEEFF;">
              <img src="assets/square-silhouette-icon.svg" alt="icon silhouette" width="40px">
              <p class="light-blue no-margin bold">Listes des électeurs bloqués</p>
            </div>

            <div style="position: relative; display: inline-block;" class="w-full">
              <input name="search" type="text" class="pap-input dark-blue w-quarter" #searchInput
                (input)="onSearch(searchInput.value)" placeholder="Rechercher..."
                style="float: right; box-sizing: border-box; padding-right: 30px;">
              <img src="assets/magnifier-icon.svg" alt="search" width="15px"
                style="position: absolute; right: 10px; transform: translateY(115%); pointer-events: none;">
            </div>
            <app-suspended-table [suspended]="filteredVoters"
              (selectedVotersChange)="setSelectedVoter($event)"></app-suspended-table>
          </div>

        </div>
      </main>

      <div style="margin-top: 62px; margin-right: 24px;">
        <p class="no-margin dark-gray text-sm">Premier pas</p>
        <p class="no-margin dark-blue bold text-sm">À VOTRE DISPOSITION :</p>
        <div class="flex info-section gap-10 mb-10 mt-20">
          <img src="assets/guide-icon.svg" alt="">
          <div>
            <p class="dark-blue no-margin text-sm">Pour réussir un scrutin</p>
            <p class="light-blue no-margin pointer text-sm" (click)="downloadGuide()">Voir nos guides</p>
          </div>
        </div>

        <div class="flex info-section gap-10 mb-10">
          <img src="assets/docs-icon.svg" alt="">
          <div>
            <p class="dark-blue no-margin text-sm">Pour tout savoir,</p>
            <p class="light-blue no-margin pointer text-sm" (click)="downloadDocuments()">Voir nos documents</p>
          </div>
        </div>

        <div class="flex info-section gap-10 mb-10">
          <img src="assets/support-icon.svg" alt="">
          <div>
            <p class="dark-blue no-margin text-sm">Pour toutes questions,</p>
            <p class="light-blue no-margin pointer text-sm" (click)="contactMail()">support_client&#64;v8te.com</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>